// FUNCTION LOADER CONTROLER
// Execute only once the page loader //
// Runs after Vue may have mounted #vue-app — .loader can be absent; never assume it exists.

export default class {
  constructor () {
    const loaderEl = document.querySelector('.loader')
    const bodyEl = document.querySelector('body')

    if (!window.sessionStorage.getItem('sessionLoaderController')) {
      bodyEl && bodyEl.classList.add('trigger-loader')
      window.sessionStorage.setItem('sessionLoaderController', 'true')
    } else if (loaderEl) {
      loaderEl.style.display = 'none'
    }
  }
}
